<template>
  <div class="main-container clearfix">
    <header class="main-header cleafix">
      <div class="logo floatl">
        <img src="../common/images/logo.png" alt="" v-if="userIsPLUS">
        <img src="../common/images/PG_logo.png" alt="" v-if="userIsPG" class="PGLogo">
      </div>
      <div class="floatr">
        <img class="user-avatar" src="../common/images/user.jpg" alt="">
        <span class="user-name">{{nickname}} <span v-if="userIsPG">宝洁</span>    </span>
        <a href="javascript:;" class="quit" title="退出登录" @click="quitDialog = true"><img
            src="../common/images/quit-btn.png" alt=""></a>
        <a href="javascript:;" v-if="userIsPLUS" class="quit" title="修改密码" @click="changePassWordDialog = true">
          <img src="../common/images/changepwd.png" alt=""></a>
      </div>
    </header>
    <!-- 左侧路由 -->
    <left-bar></left-bar>
    <!--右侧主体-->
    <div class="right-container">
      <div class="main-body">
        <!--顶部的页面信息-->
        <!--使用了筛选组件的页面需要使用这个absolute-->
        <div class="breadcrumb" :class="{'absolute':usingMyFilter}" v-if="isLevelTwo">
          <!--如果是三级页面就在自己的组件里面写这块信息，目前仅有促销员详情和体系配置是三级页面-->
          <!--这个是顶栏的左侧的字，使用了筛选组件的页面不显示此信息-->
          <span class="currPage" v-if="!usingMyFilter">{{$route.name}}</span>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item :to="{ path: 'dashboard' }">首页</el-breadcrumb-item> -->
            <el-breadcrumb-item v-for="item in $route.matched" :key="item.id">
              {{ item.name }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!--当前页面主体，哪些页面需要缓存就放在keep-alive的include属性里，仔细看了下发现没有。。。-->
        <!--<keep-alive>-->
        <router-view></router-view>
        <!--</keep-alive>-->
      </div>
    </div>
    <!--退出弹窗-->
    <el-dialog class="quitDialog dialog" title="提 示" :visible.sync="dialogShow" width="30%" center
               :show-close=false :close-on-click-modal=false :close-on-press-escape=false>
      <div class="dialog-body" v-if="loginTimeOut">
        <img src="../common/images/icon-warning.png">
        <span style="margin-left: 30px;display: inline-block;width: 100px">登陆超时 ！</span>
      </div>
      <div class="dialog-body" v-else>
        <img src="../common/images/icon-question.png">确认要退出现有账号吗？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notQuite()" type="text" size="small">取 消</el-button>
        <el-button @click="quite()" class="dialog-btn" size="small">
          <span v-if="!loginTimeOut">确定</span>
          <span v-else>重新登录</span>
        </el-button>
      </span>
    </el-dialog>
    <!--修改密码弹窗-->
    <el-dialog class="quitDialog dialog" title="修改密码" :visible.sync="changePassWordDialog" width="430px" center>
      <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" label-position="right"
               class="demo-ruleForm" style="margin-bottom: 50px">
        <el-row class="pwd">
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input type="password" v-model="ruleForm2.oldPassword" size="mini" style="width:260px"
                      placeholder="请输入旧密码"></el-input>
          </el-form-item>
        </el-row>
        <el-row class="pwd">
          <el-form-item label="新密码" prop="newPassword">
            <el-input type="password" v-model="ruleForm2.newPassword" size="mini" style="width:260px"
                      placeholder="请输入新密码"></el-input>
          </el-form-item>
        </el-row>
        <el-row class="pwd">
          <el-form-item label="确认新密码" prop="rNewPassword">
            <el-input type="password" v-model="ruleForm2.rNewPassword" size="mini" style="width:260px"
                      placeholder="确认新密码"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePassWordDialog = false" type="text" size="small">取 消</el-button>
        <el-button @click="changePwd()" class="dialog-btn" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  //180711韩金辰 整理
  import {logout, updateUserPasswoed} from '../api/index'
  import leftBar from "views/layout/leftBar.vue"
  import utils from '../common/js/util'

  export default {
    name: 'Home',
    data() {
      //不能为空，提交后台校验后，再次出发此处
      var validateOldPass = (rule, value, callback) => {
        if (value === '' || value === null) {
          return callback(new Error('旧密码不能为空'));
        } else if (this.oldPassErr) {
          return callback(new Error('旧密码输入错误'));
        } else {
          callback();
        }
      };
      //不能为空，和‘再次输入’进行对照
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } else {
          if (this.ruleForm2.rNewPassword !== '') {
            this.$refs.ruleForm2.validateField('rNewPassword');
          }
          callback();
        }
      };
      //不能为空，和‘新密码’进行对照
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入新密码'));
        } else if (value !== this.ruleForm2.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        // tabs: [],//不知道是啥，180811仍然稳定就删掉
        quitDialog: false,//退出弹窗
        changePassWordDialog: false,//修改密码弹窗
        oldPassErr: false,//校验旧密码错误时修改
        ruleForm2: {
          oldPassword: '',
          newPassword: '',
          rNewPassword: ''
        },
        rules2: {
          newPassword: [{validator: validatePass, trigger: 'blur'}],
          rNewPassword: [{validator: validatePass2, trigger: 'blur'}],
          oldPassword: [{validator: validateOldPass, trigger: 'blur'}]
        },
        nickname: '安琪儿',
        userIsPG: false,
        userIsPLUS: true,
      }
    },
    watch: {
      changePassWordDialog(newVal, oldVal) {
        if (!newVal) {
          this.$refs.ruleForm2.resetFields();
        }
      }
    },
    computed: {
      loginTimeOut() {
        return this.$store.state.loginTimeOut
      },
      dialogShow() {
        //如果允许直接修改dialogShow来关闭弹窗，则必须添加set方法
        return this.loginTimeOut || this.quitDialog
      },
      //是否使用了自己的筛选组件，看html部分的注释
      usingMyFilter(){
        let arr = ['/salespersonLibrary','/baseCenter']
        return arr.indexOf(this.$route.path) > -1
      },
      //是否使用了自己的导航栏，html部分注释不准确
      isLevelTwo(){
        let arr = ['/salespersonDetail','/SystemConfig', '/LookHistoryTwo']
        return arr.indexOf(this.$route.path) == -1
      },
    },
    components: {
      "left-bar": leftBar,
    },
    mounted() {
      this.userIsPG = Boolean(sessionStorage.getItem('usersPG'))
      this.userIsPLUS = Boolean(!this.userIsPG)

      this.nickname = sessionStorage.getItem('nickname')
      //不知道是啥，180811仍然稳定就删掉
      // if (this.tabs.length === 0 && this.$route.path !== '/') {
      //   this.tabs.push({
      //     label: this.$route.name,
      //     path: this.$route.path
      //   })
      // }
      //刷新可能会丢失title，重新赋值
      if (this.userIsPG) {
        document.title = '宝洁CRM'
      } else if (this.userIsPLUS) {
        document.title = '普乐师CRM'
      }
    },
    methods: {
      notQuite() {
        this.quitDialog = false;
        if (this.$store.state.loginTimeOut) {//如果此时是超时状态，则取消超时状态
          this.$store.commit('changeLoginTimeOutTo', false)
        }
      },
      quite() {
        //退出登录
        this.$confirm('确认退出吗?', '提示', {
        }).then(() => {
          this.quitDialog = false
          if (this.$store.state.loginTimeOut) {//如果此时是超时状态，则取消超时状态
            this.$store.commit('changeLoginTimeOutTo', false)
          }
          logout().then(res => {
            //console.log(res.data);
            //现在在main.js里面清除session和Storage，只要是登录页，就清空
            //注销后，重置routes配置
            let routes = this.$router.options.routes
            routes.map(item => {
              if (item.name != "登陆") {
                item.hidden = false
              }
              item.children.map(item2 => {
                let name = item2.name
                //二级页面的hidden永远为true
                if (name != "促销员详情" && name != "配置历史查询" && name != "配置历史查询2" && name != "登陆") {
                  item2.hidden = false
                }
              })
            })
            //其实res.data.code == 0，才是真的注销成功，这里不让用户知道太多，就提示注销成功
            utils.myNotify(this, 'success', '注销成功')
            sessionStorage.clear()
            //从哪登陆的就回哪去
            if (this.userIsPG) {
              this.$router.push('/loginPG');
            } else if (this.userIsPLUS) {
              this.$router.push('/login');
            }
          }).catch(err => {
            utils.myNotify(this, 'warning', err.response, '注销失败')
          })
        }).catch(() => {
        });
      },
      changePwd() {
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            updateUserPasswoed({
              oldPassword: this.ruleForm2.oldPassword,
              newPassword: this.ruleForm2.newPassword,
              rNewPassword: this.ruleForm2.rNewPassword,
            }).then(res => {
              utils.myNotify(this, 'success', res, '密码更新成功')
              this.changePassWordDialog = false
            }).catch(err => {
              if (err.response.data.message == '旧密码错误，请重新输入') {
                this.oldPassErr = true;
                this.$refs.ruleForm2.validateField('oldPassword')
                setTimeout(() => {
                  this.oldPassErr = false;
                }, 100)
              } else {
                utils.myNotify(this, 'error', err.response, '密码更新失败')
              }
            })
          }
        })
      }
    },
  }
</script>
<style lang="scss" scoped>
  @import "../common/styles/variable.scss";

  .main-container {
    width: 100%;
    height: 100vh;
    min-width: 1360px;
    overflow-x: auto;
    background: #f4f4f4;
    .main-header {
      background-color: $theme-font-color;
      height: 60px;
      line-height: 60px;
      box-sizing: border-box;
      padding-right: 20px;
      margin-bottom: 10px;
      .logo {
        height: 60px;
        overflow: hidden;
        .PGLogo {
          margin: 5px 26px;
          height: 30px;
        }
      }
      .user-avatar {
        width: 34px;
        height: 34px;
        border-radius: 50%;
      }
      .user-name {
        color: #fff;
        margin-left: 8px;
      }
      //退出登录的按钮
      .quit {
        display: inline-block;
        height: 60px;
        position: relative;
        padding-left: 20px;
        margin-left: 20px;
        &:after {
          content: '';
          display: block;
          position: absolute;
          top: 20px;
          left: 0;
          width: 1px;
          height: 20px;
          background: #c0c0c0;
        }
      }
    }
    .right-container {
      margin-left: 120px;
      height: calc(100% - 70px);
    }
    .main-body {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      padding: 0 20px;
      height: 100%;
      overflow-y: auto;
      background-color: #f4f4f4
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/home.vue